var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Grid, Progress } from 'semantic-ui-react';
import Button from 'components/Button/Button';
import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { closeModal, showModal } from '../../../../actions/modalActions';
import { pendingFinished } from '../../../../actions/sandboxItemActions';
import apis from '../../../../apis/index';
var SandboxAuraCloud = function (_a) {
    var data = _a.data, showActionModal = _a.showActionModal, auraPush = _a.auraPush, handlePendingFinished = _a.handlePendingFinished, startedPending = _a.startedPending, onCloseModal = _a.onCloseModal, accessToken = _a.accessToken;
    var sandboxHashKey = data.sandboxHashKey;
    var _b = useState(false), isPushSuccessful = _b[0], setIsPushSuccessful = _b[1];
    var _c = useState(false), didPushFail = _c[0], setDidPushFail = _c[1];
    var _d = useState(""), errorMsg = _d[0], setErrorMsg = _d[1];
    var onPushToAura = function () {
        setIsPushSuccessful(false);
        setErrorMsg("");
        setDidPushFail(false);
        showActionModal({ type: 'pushAura', data: __assign({}, data) });
    };
    var intervalId = useRef(null);
    var handleUiStatus = function (successStatus, failStatus) {
        clearInterval(intervalId.current);
        setDidPushFail(failStatus);
        setIsPushSuccessful(successStatus);
        handlePendingFinished();
    };
    var setErrorMessage = function (code) {
        if (code === "INVALID_CREDENTIALS") {
            setErrorMsg("Provided credentials are invalid");
            console.log("Provided credentials are invalid");
        }
        else if (code === "SIZE_TOO_BIG") {
            setErrorMsg("Destination Aura instance is too small");
            console.log("Destination Aura instance is too small");
        }
        else if (code === "INVALID_BOLT_URI") {
            setErrorMsg("Provided Aura URI is invalid");
            console.log("Provided Aura URI is invalid");
        }
        else {
            setErrorMsg("Error occurred while uploading to Aura");
            console.log("Error occurred while uploading to Aura");
        }
    };
    var checkProgress = function () {
        apis.sandbox.requestPushToAuraStatus(auraPush, accessToken)
            .then(function (response) {
            if (response.length > 1 && (response[0] instanceof Error || typeof response[1] === "undefined" || (response[1].data && response[1].data.status === "FAILED"))) {
                handleUiStatus(false, true);
                setErrorMessage(response[1].data.errorCode);
            }
            if (response.length > 1 && response[1] && response[1].data && response[1].data.status === "SUCCESS") {
                handleUiStatus(true, false);
            }
        })
            .catch(function (err) {
            console.log(err);
            if (errorMsg === "")
                setErrorMessage("UNKNOWN");
            handleUiStatus(false, true);
        });
    };
    useEffect(function () {
        if (auraPush && startedPending) {
            window.neo4jSandbox.tracking.event('SANDBOX_PUSH_TO_AURA_STATUS_REQUEST', { "key": sandboxHashKey });
            apis.sandbox.requestPushToAuraStatus(auraPush, accessToken)
                .then(function (response) {
                if (response.length > 1 && response[1] && response[1].data && response[1].data.status === "PENDING") {
                    intervalId.current = setInterval(checkProgress, 4000);
                }
                else if (response.length > 1 && response[1] && response[1].data && response[1].data.status === "FAILED") {
                    handleUiStatus(false, true);
                    setErrorMessage(response[1].data.errorCode);
                }
                else if (response.length > 1 && response[1] && response[1].data && response[1].data.status === "SUCCESS") {
                    handleUiStatus(true, false);
                }
                else {
                    if (errorMsg === "")
                        setErrorMessage("UNKNOWN");
                    handleUiStatus(false, true);
                }
            })
                .catch(function (error) {
                if (errorMsg === "")
                    setErrorMessage("UNKNOWN");
                handleUiStatus(false, true);
                console.error('An unexpected error occurred:', error);
            });
        }
        return function () {
            if (intervalId) {
                clearInterval(intervalId.current);
            }
        };
    }, [auraPush, startedPending]);
    var PushButton = function () {
        return (React.createElement(Button, { basic: true, className: startedPending ? 'font-regular disabled' : 'font-regular', onClick: onPushToAura }, "Push to Aura"));
    };
    var PendingPush = function () {
        return (React.createElement(Grid.Column, { width: 16, className: "border-bottom sandbox-extend-grid" },
            React.createElement("p", { className: "mb1 font-small" }, "Push to Aura requested"),
            React.createElement("p", { className: "font-small color-aluminum" },
                React.createElement(Progress, { percent: 100, active: true, indicating: true }, "Request is pending"))));
    };
    var FailedPush = function () {
        return (React.createElement(Grid.Column, { width: 16, className: "border-bottom sandbox-extend-grid" },
            React.createElement("p", { className: "mb1 font-small" }, "Sandbox Requested"),
            React.createElement("p", { className: "font-small color-aluminum" },
                React.createElement(Progress, { percent: 100, error: true }, errorMsg))));
    };
    var SuccessfulPush = function () {
        return (React.createElement(Grid.Column, { width: 16, className: "border-bottom sandbox-extend-grid" },
            React.createElement("p", { className: "mb1 font-small" }, "Sandbox Requested"),
            React.createElement("p", { className: "font-small color-aluminum" },
                React.createElement(Progress, { percent: 100, success: true }, "Success"))));
    };
    return (React.createElement("div", null,
        React.createElement(Grid, null,
            React.createElement(Grid.Column, { width: 16, className: "border-bottom sandbox-extended-grid" },
                React.createElement("div", { className: "pull-right" },
                    React.createElement("div", { style: { cursor: 'pointer' } },
                        React.createElement(PushButton, null)))),
            didPushFail ? FailedPush() : React.createElement("br", null),
            startedPending ? PendingPush() : React.createElement("br", null),
            isPushSuccessful ? SuccessfulPush() : React.createElement("br", null))));
};
// export default SandboxBackups
var mapDispatchToProps = function (dispatch) { return ({
    showActionModal: function (data) { return dispatch(showModal(data)); },
    handlePendingFinished: function () { return dispatch(pendingFinished()); },
    onCloseModal: function () { return dispatch(closeModal()); }
}); };
var mapStateToProps = function (state) { return ({
    accessToken: state.user.accessToken,
    auraPush: state.sandbox.auraPush,
    startedPending: state.sandbox.startedPending
}); };
export default connect(mapStateToProps, mapDispatchToProps)(SandboxAuraCloud);
